import AppSetting from "../../config/AppSetting";
import RequestOption from "../../utils/rest/RequestOption";
import RestRequest from "../../utils/rest/RestRequest";

export default class BaseService {
  creatRequestOption = (obj: any) => {
    const {
      prefixName,
      headers,
      params,
      onSuccess,
      onError,
      returnPara,
      formRequest = false,
      keepalive = false,
      noEnCode = false,
    } = obj;
    return new RequestOption({
      // @ts-ignore
      method: AppSetting.urlPrefix[prefixName].method,
      headers,
      body: params == null || formRequest ? params : JSON.stringify(params),
      // @ts-ignore
      requireAuth: AppSetting.urlPrefix[prefixName].requireAuth,
      onSuccess,
      onError,
      returnPara,
      keepalive,
      noEnCode,
    });
  };

  sendRequest = (
    prefixName: any,
    params: any,
    onSuccess: any,
    onError: any,
    returnPara: any,
    formRequest: any,
    keepalive: any
  ) => {
    // @ts-ignore
    const url = AppSetting.endpoint["common"] + AppSetting.urlPrefix[prefixName].url;
    const headers = formRequest ? {} : { "Content-Type": "application/json" };
    const requestOption = this.creatRequestOption({
      prefixName,
      headers,
      params,
      onSuccess,
      onError,
      returnPara,
      formRequest,
      keepalive,
    });
    return new RestRequest(url, requestOption).launchAsyncRequest();
  };

  sendSyncRequest = (
    prefixName: any,
    params: any,
    onSuccess: any = undefined,
    onError: any = undefined,
    returnPara: any = undefined,
    formRequest: any = undefined,
    keepalive: any = undefined
  ) => {
    // @ts-ignore
    const url = AppSetting.endpoint["common"] + AppSetting.urlPrefix[prefixName].url;
    const headers = formRequest ? {} : { "Content-Type": "application/json" };
    const requestOption = this.creatRequestOption({
      prefixName,
      headers,
      params,
      onSuccess,
      onError,
      returnPara,
      formRequest,
      keepalive,
    });
    return new RestRequest(url, requestOption).launchSyncRequest();
  };

  sendExternalRequest = (
    prefixName: any,
    params: any,
    onSuccess: any,
    onError: any,
    returnPara: any,
    formRequest: any,
    keepalive = false,
    noEnCode = false
    // contentDisposition
  ) => {
    // @ts-ignore
    const url = AppSetting.urlPrefix[prefixName].url;
    const headers = formRequest ? {} : { "Content-Type": "application/json" };
    const requestOption = this.creatRequestOption({
      prefixName,
      headers,
      params,
      onSuccess,
      onError,
      returnPara,
      formRequest,
      keepalive,
      noEnCode,
    });
    return new RestRequest(url, requestOption).launchAsyncRequest();
  };

  sendBeaconRequest = (prefixName: string, params: Record<string, any>) => {
    // @ts-ignore
    const url = AppSetting.endpoint["common"] + AppSetting.urlPrefix[prefixName].url;
    const query = new URLSearchParams(params as Record<string, string>).toString();
    const body = new URLSearchParams({
      accessToken: AppSetting.localStorageValue.token.accessToken.get() || "",
      refreshToken: AppSetting.localStorageValue.token.refreshToken.get() || "",
    });
    return navigator.sendBeacon(`${url}?${query}`, body);
  };
}
